import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { setConfig, initStore } from '../actions';
const parse = require('url-parse');

const getQS = () => {
    const { bd, px, pxq, ui } = parse(location.href, true).query;
    let path = null;
    if (pxq)
        path = [pxq]
    else if (bd && px)
        path = [bd, px]
    return [path, ui]
}

export default ({ children, config }) => {
    const dispatch = useDispatch();
    const [path, ui] = getQS();
    config.isLoading = true;
    config.path = config.path ?? path;
    config.ui = ui ?? '';
    config.appElement= config.appElement;
    dispatch(setConfig(config))
    dispatch(initStore());

    return children;
}
